import {
  Box,
  FormControl,
  FormErrorMessage,
  Text,
  Textarea,
  SystemStyleObject,
  Flex,
} from "@chakra-ui/react";
import LabelComponent from "../../atom/Label/LabelComponent";
import { FC, useState } from "react";
import { textAreaStyle } from "../../../utils/styles/styles";

interface TextAreaComponentProps {
  label: string;
  name: string;
  register: any;
  errors: any;
  isRequired?: boolean;
  isDisabled?: boolean;
  additionalStyle?: SystemStyleObject;
  extraText?: string;
  counter?: number;
  textAreaHeight?: string;
}

const TextAreaComponent: FC<TextAreaComponentProps> = ({
  label,
  name,
  register,
  errors,
  isRequired = false,
  isDisabled = false,
  additionalStyle,
  extraText,
  counter,
}) => {
  const [inputLength, setInputLength] = useState(0);
  const { onChange: registerOnChange, ...registerProps } = register(name);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (counter) {
      setInputLength(e.target.value.length);
    }
    registerOnChange(e);
  };

  return (
    <Box position="relative">
      <FormControl isInvalid={!!errors[name]} sx={additionalStyle}>
        <LabelComponent
          title={label}
          fontWeight="500"
          fontSize="md"
          {...(isRequired && { isRequired })}
        />
        <Flex gap={2.5} alignItems="flex-end">
          <Textarea
            {...registerProps}
            isDisabled={isDisabled}
            onChange={handleInputChange}
            maxLength={counter ? counter : undefined}
            resize="none"
            sx={textAreaStyle}
          />
          {extraText && (
            <Text whiteSpace="nowrap" pb="2">
              {extraText}
            </Text>
          )}
        </Flex>
        <FormErrorMessage>
          {errors[name] && errors[name].message}
        </FormErrorMessage>
      </FormControl>
      {counter && (
        <Box position="absolute" right="0" fontSize="sm">
          {inputLength}/{counter} caracteres
        </Box>
      )}
    </Box>
  );
};

export default TextAreaComponent;
